import React from "react";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";

// Новый список преимуществ (заголовки + описание)
const advantages = [
  {
    title: "Низькі стартові витрати",
    text: "Для того, щоб розпочати діяльність в арбітражі, не потрібні великі фінансові вливання.",
  },
  {
    title: "Швидкий запуск",
    text: "Новачки можуть швидко реалізувати свої рекламні кампанії та незабаром отримувати результати.",
  },
  {
    title: "Гнучкість у виборі продуктів",
    text: "Арбітраж надає широкий спектр можливостей для вибору товарів і послуг.",
  },
  {
    title: "Доступ до навчальних ресурсів",
    text: "Існує безліч навчальних матеріалів, які допомагають швидко освоїти основи арбітражу.",
  },
  {
    title: "Можливість тестування",
    text: "Новачки можуть експериментувати з різними рекламними стратегіями та каналами.",
  },
  {
    title: "Мінімальні ризики",
    text: "Завдяки можливості оперативно зупиняти нерентабельні кампанії, ризики істотно зменшуються.",
  },
  {
    title: "Спільноти підтримки",
    text: "Існує безліч онлайн-спільнот, де новачки можуть отримати корисні поради та підтримку.",
  },
  {
    title: "Потенціал для пасивного доходу",
    text: "Успішні кампанії можуть приносити стабільний дохід без активного залучення.",
  },
  {
    title: "Масштабованість",
    text: "Успішні стратегії можна легко адаптувати та розширювати, збільшуючи прибуток.",
  },
  {
    title: "Анонімність",
    text: "Новачки можуть працювати з дому без потреби привертати увагу до свого бізнесу.",
  },
  {
    title: "Здобуття знань у сфері маркетингу",
    text: "Арбітраж дозволяє отримати цінний досвід в області цифрового маркетингу.",
  },
  {
    title: "Можливість роботи з різними ринками",
    text: "Арбітраж надає можливість працювати на міжнародних ринках.",
  },
];

// Анимация заголовка
const titleVariants = {
  hidden: { opacity: 0, y: -20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

// Анимация элементов списка (item)
const itemVariants = {
  hidden: { opacity: 0, y: 20, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.4, ease: "easeOut" },
  },
};

// Функция плавного скролла к #contact
const scrollToContact = () => {
  const contactSection = document.getElementById("");
  if (contactSection) {
    contactSection.scrollIntoView({ behavior: "smooth" });
  }
};

function Vacancies() {
  return (
    <section className="vacancies">
      {/* Анимация заголовка */}
      <motion.h2
        className="vacancies__title"
        variants={titleVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.5 }}
      >
        Чому арбітраж трафіку — це чудова можливість для новачків?
      </motion.h2>

      {/* Список без анимации, только айтемы */}
      <div className="vacancies__list">
        {advantages.map((advantage, index) => (
          <motion.div
            key={index}
            className="vacancies__item"
            variants={itemVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            onClick={scrollToContact} // Добавлено скролл при клике
            style={{ cursor: "pointer" }} // Делаем курсор "указателем" при наведении
          >
            {/* 1️⃣ Нумерация */}
            <div className="vacancies__number">{index + 1}</div>

            {/* 2️⃣ Заголовок преимущества */}
            <div className="vacancies__left">
              <p className="vacancies__position">{advantage.title}</p>
            </div>

            {/* 3️⃣ Описание преимущества */}
            <div className="vacancies__right">
              <p className="vacancies__value">{advantage.text}</p>
              <FaArrowRight className="vacancies__icon" />
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default Vacancies;
